import { initialState } from './associatedPlacements.redux';
import { RootState } from 'types';
import { createSelector } from '@reduxjs/toolkit';

const selectDomain = (state: RootState) => state?.associatedPlacements || initialState;

export const selectAssociatedPlacements = createSelector([selectDomain], data => data);

export const selectApplyFilters = createSelector([selectDomain], data => data.applyFilters);
